// src/App.jsx
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginSignup from "./components/LoginSignup";
import Dashboard from "./components/Dashboard";
import UserManagement from "./components/UserManagement";
import Chatbot from "./components/Chatbot";
import WritingAssistant from "./components/WritingAssistant";
import DriveChatbot from "./components/DriveChatbot";
import TrainChatbot from "./components/TrainChatbot";
import DocumentCenter from "./components/DocumentCenter";
import SidebarLayout from "./components/SidebarLayout";

function ProtectedApp() {
  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem("user")));

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <SidebarLayout user={user} onUserChange={setUser} />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginSignup />} />
        <Route element={<ProtectedApp />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/chatbot" element={<Chatbot />} />
          <Route path="/user-management" element={<UserManagement />} />
          <Route path="/writing-assistant" element={<WritingAssistant />} />
          <Route path="/drive-chatbot" element={<DriveChatbot />} />
          <Route path="/train-chatbot" element={<TrainChatbot />} />
          <Route path="/document-center" element={<DocumentCenter />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
